import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getEnquiryList } from '../Actions/AdminAction'
import { token } from '../Actions/AuthAction';
import ReactPaginate from 'react-paginate';
import { showLoader, hideLoader } from '../../utils';
import Shimmer from '../Common/Shimmer'

export default class ListEnquiry extends Component {
    constructor(props) {
        super(props);
        this.state = {
            token: token(),
            data: [],
            totalCount: 0,
            showModel: false,
            limit: 5,
            currentPage: 0,
            search: '',
        }
    }

    componentDidMount() {
        this.loadList();
    }

    loadList = (init) => {
        const { search } = this.state;
        const model = {
            token: token(),
            page: this.state.currentPage + 1,
            search: search,
            //enquiry_type : 1/2 optional   # 1 = university, 2 = candidate
        }
        if (!init && (search)) {
            model.page = 0
            this.setState({
                currentPage: 0
            })
        }
        showLoader(this);
        getEnquiryList(model)
            .then(res => {
                hideLoader(this)
                this.setState({
                    totaldata: res.totaldata,
                    data: res.data,
                    originalData: res.data,
                    totalCount: res.totaldata
                })
            }).catch(e => hideLoader(this))


    }

    handlePageClick = (data) => {
        let selected = data.selected;
        this.setState({
            currentPage: selected
        }, () => {

            this.loadList(true);
        })
    };

    filterdata = (data) => {
        this.setState({
            currentPage: 0
        })
        if (data == 0) {
            this.loadList(true);
        } else {
            const model = {
                token: token(),
                page: this.state.currentPage + 1,
                enquiry_type: data   //   # 1 = university, 2 = candidate
            }
            showLoader(this);
            getEnquiryList(model)
                .then(res => {
                    hideLoader(this)
                    this.setState({
                        totaldata: res.totaldata,
                        data: res.data,
                        originalData: res.data,
                        totalCount: res.totaldata
                    })
                }).catch(e => hideLoader(this))
        }
    }

    render() {
        const { data, totalCount, limit } = this.state;
        return (
            <>
                <div className="row mb-4">
                    <div className="col-md-12">

                        <h4 className="table_heading position-relative">ENQUIRY LIST</h4>
                    </div>
                </div>
                <div className="card table_card mb-4">
                    <div className="card-body">
                        <div className="">
                            <form className="d-flex justify-content-between form-group tableform">
                                <div>
                                    <select onChange={(e) => this.filterdata(e.target.value)} className="form-control">
                                        <option value="0">All</option>
                                        <option value="1">University</option>
                                        <option value="2">Company</option>
                                        <option value="3">Student</option>
                                    </select>
                                </div>
                                <div className="search-box mb-2">
                                    <input className="search-text" type="text" placeholder="Search in table" />
                                    <a href="#" className="search-btn">
                                        <i className="fas fa-search"></i>
                                    </a>

                                </div>
                            </form>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-bordered" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>S.No.</th>
                                        <th>Name</th>
                                        <th>Enquiry From</th>
                                        <th>Email</th>
                                        <th>Phone Number</th>
                                        <th>City</th>
                                        <th>Message</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {
                                        this.state.data ?
                                            this.state.data.map((item, i) =>
                                                <tr>
                                                    <td>{(this.state.currentPage * this.state.limit) + (++i)}</td>
                                                    <td>{item.name}</td>
                                                    <td>{item.enquiry_type == 1 ? "University" : item.enquiry_type == 2 ? "Company" : "Student"}</td>
                                                    <td>{item.email}</td>
                                                    <td>{item.phone}</td>
                                                    <td>{item.enquiry_type == 3 ? `Candidate Name - ${item.city}` : item.city}</td>
                                                    <td>{item.message}</td>
                                                </tr>

                                            ) : <Shimmer />
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className="d-flex justify-content-between">
                            <h6><span>{`${(this.state.currentPage ? (this.state.currentPage * this.state.limit) + 1 : 1)}-${data.length < limit ? totalCount : (this.state.currentPage + 1) * this.state.limit}`}</span> <span>/ {this.state.totalCount} Search Results</span></h6>
                            <div class="pagination">
                                <ReactPaginate
                                    previousLabel={<i className="fa fa-angle-double-left" aria-hidden="true"></i>}
                                    nextLabel={<i className="fa fa-angle-double-right" aria-hidden="true"></i>}
                                    pageCount={this.state.totalCount % this.state.limit === 0 ? parseInt(this.state.totalCount / this.state.limit) : parseInt(this.state.totalCount / this.state.limit) + 1}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={10}
                                    onPageChange={this.handlePageClick}
                                    activeClassName={'active'}
                                />
                            </div>


                        </div>
                    </div>
                </div>
            </>
        )
    }
}
